<template>
  <div id="user-list" class="">
    <div class="row justify-content-center">
      <h5 class="ml-auto mr-auto">Mailing List</h5>
      <button
        type="button"
        class="btn btn-light btn-sm"
        data-toggle="modal"
        data-target="#addMailingRecordFormModal"
      >
       Add Record <i class="fas fa-add"></i>
      </button>
    </div>
    <hr />

    <CoreDatatable
      v-if="tableData.tableHeaders != null"
      :dataBase="tableData.dataBase"
      :tableHeaders="tableData.tableHeaders"
      :title="tableData.title"
      :dynamicTableId="dataTableID"
      @onTableReady="enableDatatableFeatures"
    />

    <div v-if="loading" class="overlay p-5">
      <i class="fas fa-2x fa-sync-alt fa-spin"></i>
    </div>

    <div class="row justify-content-center">
      <button
        type="button"
        class="btn btn-spnm btn-sm"
        :disabled="selectedUsers.length == 0"
        data-toggle="modal"
        data-target="#bulkMailModalDialog"
      >
        <i class="fas fa-paper-plane mr-1"></i> Send Mail
      </button>
      <button
        type="button"
        class="btn btn-danger btn-sm ml-2"
        :disabled="selectedUsers.length == 0"
        @click="deleteContact"
      >
        <i class="fas fa-trash-can"></i> Delete
      </button>
    </div>

    <!-- User Info Modal -->
    <AddMailerRecordFormVue/>
    <UserInfoModal :userData="selectedUser" />
    <BulkMailModal :allMailingList="tableData.dataBase" :preSelectedList="selectedUsers" />
  </div>
</template>
  
  <script>
import { generate } from "@vue/compiler-core";
import $ from "jquery";
import axios from "axios";
import CoreDatatable from "../Core/Datatable.vue";
import UserInfoModal from "../Admin/UserInfoModal.vue";
import BulkMailModal from "../MailingList/BulkMailModal.vue";
import AddMailerRecordFormVue from '../MailingList/AddMailerRecordForm.vue';


var table;
var databaseLength = 0;

export default {
  name: "MailingList",
  components: {
    CoreDatatable,
    UserInfoModal,
    BulkMailModal,
    AddMailerRecordFormVue
  },
  data() {
    return {
      dataTableID: "UserListTable",
      selectedUsers: [],
      userInfo: null,
      selectedUser: null,
      loading: true,
      tableData: {
        dataBase: [],
        tableHeaders: null,
        title: "Mailing List",
      },
    };
  },
  created() {},
  mounted() {
    this.getDataBase();
  },
  methods: {
    getDataBase() {
      var requestBody = {};
      var _this = this;
      this.loading = true;
      axios
        .post("/api/MailingListSource/GetList", requestBody)
        .then(function (response) {
          _this.generateTable(response.data);
          databaseLength = response.data.length;
          _this.loading = false;
        })
        .catch(function (error) {
          _this.loading = false;
          if (error.response) {
            console.log(error.response);
          } else {
            console.log(error);
          }
        });
    },

    generateTable(dataBase) {
      var tableHeaders = [
        {
          title:
            '<input type="checkbox" class=" mt-0 ml-0 select-all" id="selectAll"> ',
          data: "mailerListId",
          className: "dt-center selectAllTHeading",
          orderable: false,
          render: function () {
            return '<input type="checkbox" class=" ml-2 user-select" id="selectCheckbox">';
          },
        },

        {
          title: "First Name",
          className: "dt-left",
          data: "firstName",
        },
        {
          title: "Last Name",
          className: "dt-left",
          data: "lastName",
        },
        {
          title: "Company Name",
          className: "dt-left",
          data: "companyName",
        },
        {
          title: "Job Title",
          className: "dt-left",
          data: "jobTitle",
        },
        {
          title: "Personal Mail ID",
          className: "dt-left",
          data: "personalEmailId",
        },
        {
          title: "Contact Number",
          className: "dt-left",
          data: "personalMobileNo",
        },
      ];

      this.tableData.tableHeaders = tableHeaders;
      this.tableData.dataBase = dataBase;
    },

    enableDatatableFeatures(database) {
      table = $("#dashboardTable" + this.dataTableID).DataTable();

      var _this = this;
      $("#dashboardTable" + this.dataTableID + " tbody").on(
        "click",
        "input.user-select",

        function () {
          var rowdata = table.row($(this).parents("tr")).data();
          let obj = _this.selectedUsers.find(
            (o) => o.mailerListId === rowdata.mailerListId
          );

          if (obj) {
            _this.selectedUsers.splice(
              _this.selectedUsers.findIndex((a) => a.mailerListId === rowdata.mailerListId),
              1
            );
          } else {
            _this.selectedUsers.push(rowdata);
          }

          if (_this.selectedUsers.length == databaseLength) {
            _this.selectedUsers = _this.tableData.dataBase;
            $(".select-all").prop("checked", true);
          } else {
            $(".select-all").prop("checked", false);
          }
        }
      );

      $("#dashboardTable" + this.dataTableID + " tbody").on(
        "click",
        "span.userInfo",

        function () {
          var rowdata = table.row($(this).parents("tr")).data();
          _this.selectedUser = rowdata;
          $("#userInfoModal").modal("toggle");
        }
      );

      $("#dashboardTable" + this.dataTableID + " thead").on(
        "click",
        "input.select-all",

        function () {
          if (_this.selectedUsers.length != parseInt(databaseLength)) {
            _this.selectedUsers = _this.tableData.dataBase;
            $(".user-select").prop("checked", true);
          } else {
            _this.selectedUsers = [];
            $(".user-select").prop("checked", false);
          }
        }
      );
    },

    sendCredentials() {
      var requestBody = {
        UserCollectionItems: this.selectedUsers,
      };
      var _this = this;
      axios
        .post("/api/Membership/SendCredentials", requestBody)
        .then(function (response) {
          alert(response.data);
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response);
          } else {
            console.log(error);
          }
        });
    },

    deleteContact() {
      var requestBody = {
        MailerListIds: "",
      };

      this.selectedUsers.forEach((element) => {
        if (requestBody.MailerListIds.length == 0) {
          requestBody.MailerListIds = element.mailerListId.toString();
        } else {
          requestBody.MailerListIds =
            requestBody.MailerListIds + "," + element.mailerListId.toString();
        }
      });

      if (confirm("Are you sure to delete selected sources ?")) {
      } else {
        return;
      }

      var _this = this;

      this.loading = true;

      axios
        .post("/api/MailingListSource/Delete", requestBody)
        .then(function (response) {
          _this.getDataBase();
          _this.loading = false;
          alert(response.data);
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response);
          } else {
            console, log(error);
          }
        });
    },
  },
};
</script>
  
  <style>
.selectAllTHeading {
  padding-bottom: 5.5rem !important;
}
</style>